document.addEventListener('click', function (e) {
  const btn = e.target.closest('.read-more__toggle');
  if (!btn) return;

  const block = btn.closest('.read-more__text');
  if (!block) return;

  const content = block.querySelector('.read-more__content');
  const btnText = btn.querySelector('.btn__text');

  const showText = block.dataset.showText || 'Leggi di più';
  const hideText = block.dataset.hideText || 'Leggi meno';

  const isCollapsed = block.classList.contains('is-collapsed');

  if (isCollapsed) {
    block.classList.remove('is-collapsed');
    block.classList.add('expanded');
    content && content.classList.remove('text-limit-10-lines');
    if (btnText) btnText.textContent = hideText;
  } else {
    block.classList.add('is-collapsed');
    block.classList.remove('expanded');
    content && content.classList.add('text-limit-10-lines');
    if (btnText) btnText.textContent = showText;
  }
});
